import React from 'react'
import cx from 'classnames'
import { Container } from 'react-grid-system'
import { CardOverlayGroupType } from '~types'
import { CardOverlay } from '~elements'
import styles from './CardOverlayGroup.module.scss'

const CardOverlayGroup = ({
  cardsOverlay,
  subheadlineColor,
  makeFirstCardTaller,
  hasFullWidth = true,
  removePadding
}: CardOverlayGroupType) => {
  return (
    <>
      {cardsOverlay && cardsOverlay.length > 0 && (
        <Container
          style={{
            ...(hasFullWidth && { maxWidth: '1600px' }),
            ...(removePadding ? { padding: 0 } : { padding: '32px 24px' })
          }}
        >
          <div className={cx([styles['card-overlay-container']])}>
            {cardsOverlay.map((cardOverlay, index) => (
              <div
                key={cardOverlay?.id}
                className={cx(styles['card-column'], styles[`card-column--${index}`], {
                  [styles['card-column--is-tall']]: makeFirstCardTaller && index === 0
                })}
              >
                <CardOverlay {...cardOverlay} subheadlineColor={subheadlineColor} />
              </div>
            ))}
          </div>
        </Container>
      )}
    </>
  )
}

export default CardOverlayGroup
